<template>
  <private-template>
    <template v-slot:private-template>
      <div class="viewContainer">
        <TitleView title="Importador Oficinas"/>
        <div class="viewContainer__content">
          <ImporterManager
            action="uploadOffice"
          />
        </div>
      </div>
    </template>
  </private-template>
</template>

<script>
import PrivateTemplate from '@/templates/PrivateTemplate.vue';
import TitleView from '@/components/atoms/TitleView/TitleView.vue';
import ImporterManager from '@/components/molecules/Importers/ImporterManager.vue';

export default {
  name: 'OfficeImporterView',
  components: {
    PrivateTemplate,
    TitleView,
    ImporterManager,
  },
};
</script>
